/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M11.7646 1.584c2.8328-2.3919 7.0682-2.0345 9.4601.7983 2.3918 2.8328 2.0344 7.0682-.7983 9.46-2.639 2.2282-6.4951 2.0705-8.9442-.2516l-3.4757 2.9348 2.0984 2.4852a.7506.7506 0 1 1-1.147.9685L6.8595 15.494 2.59 19.0989a.2502.2502 0 0 0-.0297.3526l2.7979 3.3136a.7507.7507 0 0 1-1.147.9685L1.4131 20.42c-.624-.739-.5307-1.8441.2083-2.4681l8.8922-7.5082C8.635 7.6401 9.1257 3.8122 11.7646 1.584Zm8.313 1.7668C18.2207 1.1515 14.9324.874 12.7331 2.731c-2.1992 1.857-2.4767 5.1452-.6198 7.3445 1.857 2.1993 5.1453 2.4768 7.3446.6198 2.1992-1.857 2.4767-5.1452.6197-7.3445Z"
    clipRule="evenodd"
  />,
  'OnPremKeys'
);
